import React, { useState, useEffect } from "react";
import "../src/assets/components/global.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";
import Swal from "sweetalert2";

function Viewcases() {
  const [userData, setUserData] = useState([]);
  const [firstname, setFirstname] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [cases, setCases] = useState("");
  const [casestatus, setCasestatus] = useState("");
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/viewcase?firstname=${firstname}`
      )
      .then((res) => {
        console.log("checkdata", res.data);
        setUserData(res.data.users || []); // Ensure it sets an empty array if no users are returned
      })
      .catch((err) => console.log(err));
  }, [firstname]);

  const handleView = (user) => {
    setSelectedUser(user);
    setCases(user.caseType);
    setCasestatus(user.casestatus);
    setShowUpdateForm(true);
  };

  const handleSearchInputChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleUpdateCases = () => {
    Swal.fire({
      title: "Do you want to Continue?",
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Continue it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const casesData = {
          caseType: cases,
          casestatus: casestatus,
        };

        axios
          .put(
            `https://brgytracerappserver.onrender.com/viewcases/${selectedUser.brgyId}`,
            casesData
          )
          .then((res) => {
            if (res.data.status === "success") {
              Swal.fire({
                title: "Updated Cases!",
                text: "Successfully Updated!",
                icon: "success",
              }).then(() => {
                setSelectedUser(null);
                setCases("");
                setCasestatus("");
                setShowUpdateForm(false);
                window.location.reload();
              });
            }
          })
          .catch((err) => console.log(err));
      }
    });
  };

  const handleClose = () => navigate("/officerpage");

  const handleCancel = () => {
    setShowUpdateForm(false);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(userData.length / rowsPerPage))
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, userData.length);
  const currentUsers = userData.slice(startIndex, endIndex);

  return (
    <div className="officerpage-parent parent-height viewcases">
      <AutoLogout />
      <div className="container">
        <div className="searchbox">
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={firstname}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className="datagrid-parent">
          <button type="button" className="closebtn" onClick={handleClose}>
            X
          </button>
          <h1>List of Users</h1>
          {currentUsers.length > 0 ? (
            <div className="datagrid-holder">
              <table>
                <thead>
                  <tr>
                    <th>BrgyId</th>
                    <th>First Name</th>
                    <th>Family Name</th>
                    <th>Gender</th>
                    <th>CaseType</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user, index) => (
                    <tr key={`${user.brgyId}-${index}`}>
                      <td>{user.brgyId}</td>
                      <td>{user.firstname}</td>
                      <td>{user.lastname}</td>
                      <td>{user.gender}</td>
                      <td>{user.caseType}</td>
                      <td>{user.casestatus}</td>
                      <td
                        className="handleView"
                        onClick={() => handleView(user)}>
                        view
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-controls">
                <button
                  className="pagination-button"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}>
                  Previous
                </button>
                <span className="pagination-info">
                  Page {currentPage} of{" "}
                  {Math.ceil(userData.length / rowsPerPage)}
                </span>
                <button
                  className="pagination-button"
                  onClick={handleNextPage}
                  disabled={
                    currentPage === Math.ceil(userData.length / rowsPerPage)
                  }>
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p className="noUsertext">No users available for display.</p>
          )}
        </div>
        {showUpdateForm && selectedUser && (
          <div className="Updateform-parent">
            <form className="update-container">
              <div className="text-group-holder">
                <label>BrgyID: {selectedUser.brgyId}</label>
                <label>First Name: {selectedUser.firstname}</label>
                <label>Family Name: {selectedUser.lastname}</label>
                <label>Gender: {selectedUser.gender}</label>
                <div className="form-group">
                  <label htmlFor="Cases">Cases:</label>
                  <select
                    value={cases}
                    onChange={(e) => setCases(e.target.value)}
                    required>
                    <option value="Settlement">Settlement</option>
                    <option value="Blotter">Blotter</option>
                    <option value="Crime">Crime</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="Status">Status:</label>
                  <select
                    value={casestatus}
                    onChange={(e) => setCasestatus(e.target.value)}
                    required>
                    <option value="Active">Active</option>
                    <option value="Ongoing">Ongoing</option>
                    <option value="Settled">Settled</option>
                  </select>
                </div>
              </div>
              <div className="button-holder">
                <button type="button" onClick={handleUpdateCases}>
                  Update
                </button>
                <button
                  className="hidebtn"
                  type="button"
                  onClick={handleCancel}>
                  Close
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default Viewcases;
